<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('codeEvent.eventSet')" name="first">
        <div class="list-set">
          <el-form
            :inline="true"
            :model="formInline"
            class="demo-form-inline"
            style="margin-bottom: 10px"
            @submit.native.prevent="triggerClick('evet')"
          >
            <div style="display: flex; align-items: center">
              <el-input
                v-model="formInline.keyword"
                size="small"
                :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventName')"
              ></el-input>
              <el-button
                style="margin: 0 10px 0 0"
                size="mini"
                type="primary"
                @click="handleSqlSearch('search')"
                >{{$t('configMoudle.search')}}</el-button
              >
              <el-button
                style="margin: 0 10px 0 0"
                size="mini"
                type="primary"
                @click="handleSqlSearch('reset')"
                >{{$t('configMoudle.reset')}}</el-button
              >
            </div></el-form
          >
          <Y-button
            :button="button"
            style="margin-bottom: 10px"
            @handleClickButton="handleClickButton"
          />
          <div>
            <Y-table
              ref="listTable"
              :column="column"
              :tableData="tableData"
              :row-class-name="changeRowClassName"
              :rowKey="'id'"
              :alingitem="'alignType'"
              :selection="false"
              :handleBtn="handleBtn"
              :handleWidth="'160'"
              height="650px"
              @handleClickHandle="handleClickHandle"
            >
            </Y-table>
            <!-- 分页组件 -->
            <Y-page
              :total="total"
              :currentPage="page.pageNum"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
          <el-dialog
            :title="$t('codeEvent.eventSet')"
            :visible.sync="visiable"
            :close-on-click-modal="false"
            append-to-body
            width="50%"
            :before-close="handleClose"
          >
            <el-form :model="form" label-width="180px">
              <el-form-item :label="$t('codeEvent.eventName')">
                <el-input
                  v-model="form.eventName"
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventName')"
                  style="width: 65%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('codeEvent.eventId')">
                <el-select
                  v-model="form.eventId"
                  :laceholder="$t('codeEvent.placeSet')+$t('codeEvent.eventId')"
                  style="width: 65%;"
                >
                  <el-option :label="$t('codeEvent.fieldChange')" value="字段变动"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('codeEvent.field')">
                <el-select
                  v-model="form.fields"
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventId')"
                  style="width: 65%;"
                  multiple
                  filterable
                >
                  <el-option-group
                    v-for="group in fieldList"
                    :key="group.header"
                    :label="group.header"
                  >
                    <el-option
                      v-for="item in group.itemList"
                      :key="item.itemName"
                      :label="item.itemShowName"
                      :value="item.itemName"
                    >
                    </el-option>
                  </el-option-group>
                  <!-- <el-option
                    v-for="item in fieldList"
                    :key="item.itemName"
                    :label="item.itemShowName"
                    :value="item.itemName"
                  >
                  </el-option> -->
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('codeEvent.status')">
                <el-switch
                  v-model="form.status"
                  :active-value="0"
                  :inactive-value="1"
                  >></el-switch
                >
              </el-form-item>
              <el-form-item :label="$t('codeEvent.eventContent')">
                <el-input
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventContent')"
                  v-model="form.script"
                  type="textarea"
                  style="width: 65%"
                  :rows="24"
                />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                size="small"
                :loading="loading"
                @click="submitForm"
                >{{ $t('configMoudle.confirm') }}</el-button
              >
              <el-button @click="handleClose" size="small">{{ $t('configMoudle.cancel') }}</el-button>
            </div>
          </el-dialog>
        </div></el-tab-pane
      >
      <el-tab-pane :label="$t('codeEvent.sqlConfig')" name="second">
        <div class="list-set">
          <el-form
            :inline="true"
            :model="sqlFormInline"
            class="demo-form-inline"
            style="margin-bottom: 10px"
            @submit.native.prevent="triggerClick('sql')"
          >
            <div style="display: flex; align-items: center">
              <el-input
                v-model="sqlFormInline.keyword"
                size="small"
                :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventName')"
              ></el-input>
              <el-button
                style="margin: 0 10px 0 0"
                size="mini"
                type="primary"
                @click="handleSearch('search')"
                >{{$t('configMoudle.search')}}</el-button
              >
              <el-button
                style="margin: 0 10px 0 0"
                size="mini"
                type="primary"
                @click="handleSearch('reset')"
                >{{$t('configMoudle.reset')}}</el-button
              >
            </div></el-form
          >
          <Y-button
            :button="button"
            style="margin-bottom: 10px"
            @handleClickButton="handleSqlClickButton"
          />
          <div>
            <Y-table
              ref="listTable"
              :column="sqlColumn"
              :tableData="sqlTableData"
              :row-class-name="changeRowClassName"
              :rowKey="'id'"
              :alingitem="'alignType'"
              :selection="false"
              :handleBtn="handleBtn"
              :editCell="false"
              :handleWidth="'160'"
              height="650px"
              @handleClickHandle="handleClickSqlHandle"
            >
            </Y-table>
            <!-- 分页组件 -->
            <Y-page
              :total="sqlTotal"
              :currentPage="sqlPage.pageNum"
              @handleSizeChange="handleSqlSizeChange"
              @handleCurrentChange="handleSqlCurrentChange"
            />
          </div>
          <el-dialog
            :title="$t('codeEvent.sqlConfig')"
            :visible.sync="sqlVisiable"
            :close-on-click-modal="false"
            append-to-body
            width="50%"
            :before-close="handleSqlClose"
          >
            <el-form :model="sqlForm" label-width="180px">
              <el-form-item :label="$t('codeEvent.name')">
                <el-input
                  v-model="sqlForm.eventName"
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.name')"
                  style="width: 65%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('codeEvent.remark')">
                <el-input
                  v-model="sqlForm.remark"
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.remark')"
                  style="width: 65%"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('codeEvent.eventContent')">
                <el-input
                  :placeholder="$t('codeEvent.placeSet')+$t('codeEvent.eventContent')"
                  v-model="sqlForm.script"
                  type="textarea"
                  style="width: 65%"
                  :rows="24"
                />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                size="small"
                :loading="loading"
                @click="submitSqlForm"
                >>{{ $t('configMoudle.confirm') }}</el-button
              >
              <el-button @click="handleSqlClose()" size="small"
                >>{{ $t('configMoudle.cancel') }}</el-button
              >
            </div>
          </el-dialog>
        </div>
      </el-tab-pane></el-tabs
    >
  </div>
</template>

<script>
import {
  initListCodeEvent,
  saveListCodeEvent,
  delListCodeEvent,
  initListCodeSql,
  saveListCodeSql,
  delListCodeSql,
} from "@/api/sysTem/codeEvent";
import { getFormulaById } from "@/api/sysTem/index";
import { first } from "xe-utils";
export default {
  name: 'codeEventSet',
  props: {
    dataIdThree: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataId: '',
      activeName: "first",
      loading: false,
      visiable: false,
      //表格字段
      column: [
        {
          prop: "eventId",
          alignType: 2,
          label: this.$t('codeEvent.eventId'),
        },
        {
          prop: "eventName",
          label:this.$t('codeEvent.eventName'),
          alignType: 2,
        },
        {
          prop: "status",
          label: this.$t('codeEvent.status'),
          alignType: 2,
        },
      ],
      tableData: [],
      formInline: {},
      handleBtn: [
        {
          class: "el-icon-edit",
          key: "edit",
          title: this.$t("listOfSet.edit"),
        },
        {
          class: "el-icon-delete",
          key: "delete",
          title: this.$t("listOfSet.delete"),
        },
      ],
      button: [{ key: "add", label: this.$t("listOfSet.add") }],
      total: 0,
      page: { pageSize: 20, pageNum: 1 },
      form: {
        fields: [],
        status: 0,
      },
      fieldList: [],
      sqlColumn: [
        {
          prop: "eventName",
          label: this.$t('codeEvent.eventName'),
        },
        {
          prop: "remark",
          label: this.$t('codeEvent.remark'),
        },
      ],
      sqlTableData: [],
      sqlTotal: 0,
      sqlPage: { pageSize: 20, pageNum: 1 },
      sqlForm: {
        fields: [],
      },
      sqlVisiable: false,
      sqlFormInline: {},
    };
  },
  activated() {
    this.activeName = "first"
    this.init();
  },
  watch: {
    dataIdThree: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    }
  },
  methods: {
    handleClick() {
      if (this.activeName === "first") {
        this.init();
      } else {
        this.sqlInit();
      }
    },
    getFieldList() {
      getFormulaById(this.dataId || this.$route.query.id).then((res) => {
        if (res && res.length !== 0) {
          this.fieldList = res.map((item) => {
            if (item.itemList) {
              item.itemList = item.itemList.filter((item) => item.itemShowName);
            }
            return item;
          });
        }
      });
    },
    submitForm() {
      let info = JSON.parse(JSON.stringify(this.form));
      info.configId = this.dataId || this.$route.query.id;
      info.script = JSON.stringify(info.script);
      if (!info.id) {
        info.status = 0;
      }
      if (info.fields) {
        info.fields = info.fields.join(",");
      }
      saveListCodeEvent(info).then((res) => {
        this.$message.success("保存成功");
        this.handleClose();
      });
    },
    submitSqlForm() {
      let info = JSON.parse(JSON.stringify(this.sqlForm));
      info.configId = this.dataId || this.$route.query.id;
      saveListCodeSql(info).then((res) => {
        this.$message.success("保存成功");
        this.handleSqlClose();
      });
    },
    //行className
    changeRowClassName({ row, rowIndex }) {
      row.$index = rowIndex;
    },
    init() {
      this.tableData = [];
      const info = {
        keyword: this.formInline.keyword,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      // initListCodeEvent(this.$route.query.id, info).then((res) => {
      initListCodeEvent(this.dataId || this.$route.query.id, info).then((res) => {
        if (res && res.length !== 0) {
          this.tableData = res.map((item) => {
            item.status = item.status === 1 ?this.$t('DictSet.disAbled') : this.$t('DictSet.enabled');
            return item;
          });
          this.total = res.length;
        }
      });
    },
    sqlInit() {
      const info = {
        keyword: this.sqlFormInline.keyword,
        pageNum: this.sqlPage.pageNum,
        pageSize: this.sqlPage.pageSize,
      };
      initListCodeSql(this.dataId || this.$route.query.id, info).then((res) => {
        this.sqlTableData = res;
        this.sqlTotal = res.length;
      });
    },
    handleSearch(type) {
      if (type === "search") {
        this.init();
      } else {
        this.formInline = {};
        this.init();
      }
    },
    handleSqlSearch(type) {
      if (type === "search") {
        this.sqlInit();
      } else {
        this.formInline = {};
        this.sqlInit();
      }
    },
    triggerClick(type) {
      switch (type) {
        case "event":
          this.init();
          break;
        case "sql":
          this.sqlInit();
          break;
        default:
          break;
      }
    },
    handleClickButton(type) {
      switch (type) {
        case "add":
          this.visiable = true;
          this.getFieldList();
          break;
        default:
          break;
      }
    },
    handleSqlClickButton(type) {
      switch (type) {
        case "add":
          this.sqlVisiable = true;
          break;
        default:
          break;
      }
    },
    handleSqlCurrentChange(val) {
      this.sqlPage.pageNum = val;
      this.sqlInit();
    },
    handleSqlSizeChange(val) {
      this.sqlPage.pageSize = val;
      this.sqlInit();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.init();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.init();
    },
    handleClickHandle({ title, scope: { row } }) {
      switch (title) {
        case "edit":
          this.visiable = true;
          this.getFieldList();
          this.form = JSON.parse(JSON.stringify(row));
          if (this.form.script) {
            this.form.script = JSON.parse(this.form.script);
          }
          if (this.form.fields) {
            this.form.fields = this.form.fields.split(",");
          }
          this.form.status = this.form.status === this.$t('DictSet.disAbled')  ? 1 : 0;
          break;
        case "delete":
          delListCodeEvent(row.id).then((res) => {
            this.$message.success("删除成功");
            this.init();
          });
          break;
        default:
          break;
      }
    },
    handleClickSqlHandle({ title, scope: { row } }) {
      switch (title) {
        case "edit":
          this.sqlVisiable = true;
          this.sqlForm = JSON.parse(JSON.stringify(row));
          if (this.sqlForm.script) {
            this.sqlForm.script = JSON.parse(this.sqlForm.script);
          }
          break;
        case "delete":
          delListCodeSql(row.id).then((res) => {
            this.$message.success("删除成功");
            this.sqlInit();
          });
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.visiable = false;
      this.form = {
        status: 0,
        fileds: [],
      };
      this.init();
    },
    handleSqlClose() {
      this.sqlVisiable = false;
      this.sqlInit();
    },
  },
};
</script>

<style scoped lang="scss">
.el-input {
  width: 180px;
  margin-right: 10px;
}

.list-set {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.el-form-item {
  margin-bottom: 15px;
}
</style>
